import { useState, useEffect } from "react";
import { useSpring } from "motion/react";

/**
 * Hook for animating numeric values with a spring animation
 * @param {number} value - The target value to animate to
 * @param {object} options - Spring configuration options
 * @param {number} options.stiffness - Spring stiffness (default: 80)
 * @param {number} options.damping - Spring damping (default: 18)
 * @param {number} options.mass - Spring mass (default: 1)
 * @returns {number} - The current animated value (rounded)
 */
const useAnimatedCount = (value, options = {}) => {
  const { stiffness = 80, damping = 18, mass = 1 } = options;
  const [displayValue, setDisplayValue] = useState(value);
  const spring = useSpring(value, {
    stiffness,
    damping,
    mass,
  });

  useEffect(() => {
    spring.set(value);
  }, [spring, value]);

  useEffect(() => {
    const unsubscribe = spring.on("change", (latest) => {
      setDisplayValue(Math.round(latest));
    });

    return () => {
      unsubscribe();
    };
  }, [spring]);

  return displayValue;
};

export default useAnimatedCount;
